module.exports = __webpack_public_path__ + "img/Miral.96a4ab51.webp";